import { typography } from "../../foundations/typography";
import { rgba, universe } from "../../foundations/universe";
/**
 * The colors that make the light mode of our Base Theme
 * @see [Documentation](https://zeroheight.com/85877f0ae/p/9612c3-color-guidelines/t/66f724)
 */

export var baseThemeLight = Object.freeze({
  // Primary
  primaryDefault: universe.borealis60,
  primaryHover: universe.borealis70,
  primaryActive: universe.borealis80,
  primaryFocus: universe.borealis40,
  primarySelected: universe.borealis60,
  primaryDisabled: universe.moonlight20,
  // On Primary
  onPrimaryHigh: universe.moonlight0,
  onPrimaryMedium: universe.moonlight20,
  onPrimaryLow: universe.moonlight30,
  onPrimaryDisabled: universe.moonlight40,
  // Link
  linkDefault: universe.borealis70,
  linkActive: universe.borealis90,
  linkVisited: universe.nebula90,
  // Surface
  surfaceDefault: universe.moonlight0,
  surfaceGradientDefault: "linear-gradient(".concat(universe.moonlight0, "00, ").concat(universe.moonlight0, "FF)"),
  surfaceGradientInverted: "linear-gradient(".concat(universe.moonlight0, "FF, ").concat(universe.moonlight0, "00)"),
  surfaceHover: universe.moonlight20,
  surfaceActive: universe.borealis10,
  surfaceFocus: universe.borealis60,
  surfaceSelected: universe.borealis10,
  surfaceDisabled: universe.moonlight10,
  // On Surface
  onSurfaceHigh: universe.moonlight90,
  onSurfaceMedium: universe.moonlight70,
  onSurfaceLow: universe.moonlight60,
  onSurfaceDisabled: universe.moonlight40,
  onSurfaceError: universe.mars90,
  // Background
  backgroundDefault: universe.moonlight10,
  backgroundGradientDefault: "linear-gradient(".concat(universe.moonlight10, "00, ").concat(universe.moonlight10, "FF)"),
  backgroundGradientInverted: "linear-gradient(".concat(universe.moonlight10, "FF, ").concat(universe.moonlight10, "00)"),
  // On Background
  onBackgroundHigh: universe.moonlight90,
  onBackgroundMedium: universe.moonlight70,
  onBackgroundLow: universe.moonlight60,
  onBackgroundDisabled: universe.moonlight40,
  onBackgroundError: universe.mars90,
  // Status
  statusInfoDefault: universe.earth20,
  statusInfoAlt: universe.earth10,
  statusSuccessDefault: universe.borealis20,
  statusSuccessAlt: universe.borealis10,
  statusWarningDefault: universe.stardust20,
  statusWarningAlt: universe.stardust10,
  statusErrorDefault: universe.mars30,
  statusErrorAlt: universe.mars10,
  // On Status
  onStatusHigh: universe.moonlight90,
  onStatusInfoDefault: universe.moonlight0,
  onStatusInfoAlt: universe.earth90,
  onStatusSuccessDefault: universe.moonlight0,
  onStatusSuccessAlt: universe.borealis90,
  onStatusWarningDefault: universe.moonlight0,
  onStatusWarningAlt: universe.stardust100,
  onStatusErrorDefault: universe.moonlight0,
  onStatusErrorAlt: universe.mars90,
  // Border
  borderDefault: universe.moonlight30,
  borderFocus: universe.borealis60,
  borderDisabled: universe.moonlight20,
  borderError: universe.mars70,
  // Skeleton
  skeletonDefault: universe.moonlight30,
  // Overlay
  overlayDefault: rgba(universe.moonlight0, 0.8),
  // Buy
  buyDefault: universe.borealis70,
  buyAlt: rgba(universe.borealis70, 0.2),
  buyHover: universe.borealis80,
  buyActive: universe.borealis90,
  buyFocus: universe.borealis40,
  // Sell
  sellDefault: universe.mars70,
  sellAlt: rgba(universe.mars70, 0.2),
  sellHover: universe.mars80,
  sellActive: universe.mars90,
  sellFocus: universe.mars40,
  //LabelActionPrimary
  labelActionPrimaryDisabled: universe.moonlight30
});
/**
 * The colors that make the dark mode of our Base Theme
 * @see [Documentation](https://zeroheight.com/85877f0ae/p/9612c3-color-guidelines/t/67243b)
 */

export var baseThemeDark = Object.freeze({
  // Primary
  primaryDefault: universe.borealis60,
  primaryHover: universe.borealis70,
  primaryActive: universe.borealis80,
  primaryFocus: universe.borealis40,
  primarySelected: universe.borealis60,
  primaryDisabled: universe.moonlight70,
  // On Primary
  onPrimaryHigh: universe.moonlight0,
  onPrimaryMedium: universe.moonlight20,
  onPrimaryLow: universe.moonlight30,
  onPrimaryDisabled: universe.moonlight80,
  // Link
  linkDefault: universe.borealis50,
  linkActive: universe.borealis70,
  linkVisited: universe.nebula50,
  // Surface
  surfaceDefault: universe.moonlight90,
  surfaceGradientDefault: "linear-gradient(".concat(universe.moonlight90, "00, ").concat(universe.moonlight90, "FF)"),
  surfaceGradientInverted: "linear-gradient(".concat(universe.moonlight90, "FF, ").concat(universe.moonlight90, "00)"),
  surfaceHover: universe.moonlight80,
  surfaceActive: universe.borealis90,
  surfaceFocus: universe.borealis60,
  surfaceSelected: universe.borealis90,
  surfaceDisabled: universe.moonlight90,
  // On Surface
  onSurfaceHigh: universe.moonlight0,
  onSurfaceMedium: universe.moonlight30,
  onSurfaceLow: universe.moonlight40,
  onSurfaceDisabled: universe.moonlight70,
  onSurfaceError: universe.mars50,
  // Background
  backgroundDefault: universe.moonlight100,
  backgroundGradientDefault: "linear-gradient(".concat(universe.moonlight100, "00, ").concat(universe.moonlight100, "FF)"),
  backgroundGradientInverted: "linear-gradient(".concat(universe.moonlight100, "FF, ").concat(universe.moonlight100, "00)"),
  // On Background
  onBackgroundHigh: universe.moonlight0,
  onBackgroundMedium: universe.moonlight30,
  onBackgroundLow: universe.moonlight40,
  onBackgroundDisabled: universe.moonlight40,
  onBackgroundError: universe.mars50,
  // Status
  statusInfoDefault: universe.earth20,
  statusInfoAlt: universe.earth90,
  statusSuccessDefault: universe.borealis20,
  statusSuccessAlt: universe.borealis90,
  statusWarningDefault: universe.stardust20,
  statusWarningAlt: universe.stardust90,
  statusErrorDefault: universe.mars30,
  statusErrorAlt: universe.mars90,
  // On Status
  onStatusHigh: universe.moonlight90,
  onStatusInfoDefault: universe.moonlight0,
  onStatusInfoAlt: universe.earth10,
  onStatusSuccessDefault: universe.moonlight0,
  onStatusSuccessAlt: universe.borealis10,
  onStatusWarningDefault: universe.moonlight0,
  onStatusWarningAlt: universe.stardust10,
  onStatusErrorDefault: universe.moonlight100,
  onStatusErrorAlt: universe.mars10,
  //Border
  borderDefault: universe.moonlight70,
  borderFocus: universe.borealis60,
  borderDisabled: universe.moonlight80,
  borderError: universe.mars70,
  // Skeleton
  skeletonDefault: universe.moonlight80,
  // Overlay
  overlayDefault: rgba(universe.moonlight100, 0.8),
  // Buy
  buyDefault: universe.borealis50,
  buyAlt: rgba(universe.borealis50, 0.2),
  buyHover: universe.borealis80,
  buyActive: universe.borealis90,
  buyFocus: universe.borealis40,
  // Sell
  sellDefault: universe.mars50,
  sellAlt: rgba(universe.mars50, 0.2),
  sellHover: universe.mars80,
  sellActive: universe.mars90,
  sellFocus: universe.mars40,
  // LabelActionPrimary
  labelActionPrimaryDisabled: universe.moonlight30
});
/**
 * Our base theme.
 * You can use these colors for Consumer and Alpha digital products and landing pages.
 * @see [Documentation](https://zeroheight.com/85877f0ae/p/9612c3-color-guidelines/t/087f51)
 */

export var baseTheme = Object.freeze({
  light: {
    colors: baseThemeLight,
    typography: typography,
    attributes: {
      theme: 'base',
      mode: 'light'
    }
  },
  dark: {
    colors: baseThemeDark,
    typography: typography,
    attributes: {
      theme: 'base',
      mode: 'dark'
    }
  }
});